import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom'

import { point } from'@turf/helpers'
import bearing from '@turf/bearing'

import { useSelector } from 'react-redux'



// 1:   1 minute  video 
// 10: 10 minutes video  
const mapUpdateTimeGapMsec = 300 // 100 1000
const recordingLengthMinutes = 10  // 4.8 ;

const anims = {
  begintime: (new Date('2022-10-08T08:00:00')).getTime(), 
  fireTime:  0,
  anims: [
    // [1, { bearing: 90, pitch: 45, zoom: 10, center: [20.0734, 46.3602], duration: null }],
[1, null, false, null],   // empty 
[2, null, false, {center: [16.505462, 47.341459], duration: null, zoom: 9, bearing: 120, pitch: 50, easing: easeLinear}, 1], //     // TÚRA-001
    // [1, null, false, {center: [16.67621971, 47.36320296], duration: null }, 3],   // TÚRA-002
    // [1, null, false, {center: [16.67621971, 47.36320296], duration: null }, 3],   // TÚRA-003
    // [1, null, false, {center: [16.93749708, 47.25282246], duration: null }, 3],   // TÚRA-004
    // [1, null, false, {center: [16.93749708, 47.25282246], duration: null, bearing: 120 }, 3],   // TÚRA-005
    // //[1, null, false, {center: [17.01521527, 47.21812978], duration: null }, 3],   // TÚRA-006
    // [1, null, false, {center: [17.02233288, 47.09190479], duration: null, bearing: 160 }, 3],   // TÚRA-007
    // [1, null, false, {center: [17.02233288, 47.09190479], duration: null }, 3],   // TÚRA-008
    // [1, null, false, {center: [17.16776586, 47.02596067], duration: null }, 3],   // TÚRA-009
    // [2, null, false, {center: [17.22782546, 46.88834981], duration: null }, 3],   // TÚRA-010
    // //[1, null, false, {center: [17.22782546, 46.88834981], duration: null }, 3],   // TÚRA-011
[7, null, false, {center: [17.4290248, 46.87735482], duration: null, easing: easeLinear }, 1],   // TÚRA-012  // bearing: 70
    //[1, null, false, {center: [17.4290248, 46.87735482], duration: null }, 3],   // TÚRA-013
    //[1, null, false, {center: [17.5133653, 46.84937268], duration: null, easing: easeLinear }, 1.5],   // TÚRA-014
    //[1, null, false, {center: [17.5133653, 46.84937268], duration: null, easing: easeLinear }, 1],   // TÚRA-015
    //[2, null, false, {center: [17.61523668, 46.91220288], duration: null, bearing: 90, easing: easeLinear }, 1],   // TÚRA-016
    //[1, null, false, {center: [17.61523668, 46.91220288], duration: null }, 3],   // TÚRA-017
[2, null, false, {center: [17.696025, 46.98235], duration: null, bearing: 50, easing: easeLinear }, 1],   // TÚRA-018
    //[1, null, false, {center: [17.65372395, 47.14806982], duration: null }, 3],   // TÚRA-019
    //[1, null, false, {center: [17.72147401, 47.25761148], duration: null }, 3],   // TÚRA-020
//    [2, null, false, {center: [17.87791422, 47.26659498], duration: null, easing: easeLinear }, 1],   // TÚRA-021
//    [1, null, false, {center: [18.19712896, 47.24495571], duration: null }, 3],   // TÚRA-022
//    [2, null, false, {center: [18.19712896, 47.24495571], duration: null, easing: easeLinear }, 1],   // TÚRA-023
    //[1, null, false, {center: [18.39061395, 47.39193472], duration: null }, 3],   // TÚRA-024
//    [2, null, false, {center: [18.39061395, 47.39193472], duration: null, easing: easeLinear }, 1],   // TÚRA-025
    //[1, null, false, {center: [18.49622075, 47.51855232], duration: null }, 3],   // TÚRA-026
[4, null, false, {center: [18.49622075, 47.51855232], duration: null , bearing: 40, easing: easeLinear }, 1],   // TÚRA-027
//    [1, null, false, {center: [18.454222, 47.665167], duration: null, zoom: 10, easing: easeLinear }, 1],   // TÚRA-028
    //[1, null, false, {center: [18.454222, 47.665167], duration: null }, 3],   // TÚRA-029
    //[1, null, false, {center: [18.73284652, 47.72311072], duration: null }, 3],   // TÚRA-030
//    [2, null, false, {center: [18.73284652, 47.72311072], duration: null, bearing: 70, zoom: 11, easing: easeLinear }, 1],   // TÚRA-031
    //[1, null, false, {center: [18.96480346, 47.54193208], duration: null, easing: easeLinear }, 1],   // TÚRA-032
[4, null, false, {center: [18.96480346, 47.54193208], duration: null, zoom: 12, bearing: 20, pitch: 60, easing: easeLinear }, 1],   // TÚRA-033  HÚVÖSVÖLGY
[2, null, false, {center: [18.9937778, 47.58732697], duration: null, zoom: 11, bearing: 50, easing: easeLinear }, 1],   // TÚRA-034
//  [3, null, false, {center: [18.98870997, 47.72323016], duration: null, zoom: 10, easing: easeLinear }, 1],   // TÚRA-035
    //[1, null, false, {center: [18.98870997, 47.72323016], duration: null }, 3],   // TÚRA-036
    //[2, null, false, {center: [18.93590351, 47.87453588], duration: null, easing: easeLinear }, 1],   // TÚRA-037
    //[1, null, false, {center: [18.93590351, 47.87453588], duration: null }, 3],   // TÚRA-038
[3, null, false, {center: [19.10525771, 47.85572138], duration: null, bearing: 70, zoom: 9, pitch: 50, easing: easeLinear }, 1],   // TÚRA-039

    //[1, null, false, {center: [19.10525771, 47.85572138], duration: null }, 3],   // TÚRA-040
    [2, null, false, {center: [19.25799475, 47.92556576], duration: null, easing: easeLinear }, 1],   // TÚRA-041
    //[1, null, false, {center: [19.25799475, 47.92556576], duration: null }, 3],   // TÚRA-042
    //[1, null, false, {center: [19.37609718, 47.91023575], duration: null }, 3],   // TÚRA-043
    [3, null, false, {center: [19.42538559, 47.97591314], duration: null, bearing: 90, pitch: 50, easing: easeLinear }, 1],   // TÚRA-044
    //[1, null, false, {center: [19.60790754, 47.93824955], duration: null }, 3],   // TÚRA-045
    [3, null, false, {center: [19.70187801, 47.997067],  duration: null, zoom: 11, easing: easeLinear }, 1],   // TÚRA-046
    [3, null, false, {center: [19.77843381, 47.97318993], duration: null, bearing: 100, zoom: 12, pitch: 70, easing: easeLinear }, 1],   // TÚRA-047



    //[1, null, false, {center: [19.77843381, 47.97318993], duration: null }, 3],   // TÚRA-048
    [6, null, false, {center: [19.917891, 47.915312],     duration: null, bearing: 110, zoom: 13.5, pitch: 70, easing: easeLinear }, 1],   // galyatető 
    // [1, null, false, {center: [20.00821924, 47.87320881], duration: null, easing: easeLinear }, 1],   // TÚRA-049
    [5, null, false, {center: [20.00821924, 47.87320881], duration: null, zoom: 13.5, easing: easeLinear }, 1],   // TÚRA-050
    [4, null, false, {center: [20.065299,   47.872692],   duration: null, bearing: 80, zoom: 12, pitch: 60, easing: easeLinear }, 1],
    //[1, null, false, {center: [20.33093836, 47.98802319], duration: null }, 3],   // TÚRA-051
    [4, null, false, {center: [20.33093836, 47.98802319], duration: null, zoom: 11, pitch: 50, easing: easeLinear }, 1],   // TÚRA-052  szarvaskő
    //[1, null, false, {center: [20.35071297, 48.0549008], duration: null }, 3],   // TÚRA-053
    [2, null, false, {center: [20.43825001, 48.2159], duration: null, zoom: 8.2, easing: easeLinear }, 1],   // TÚRA-054
    //[1, null, false, {center: [20.43825001, 48.2159], duration: null }, 3],   // TÚRA-055
    //[1, null, false, {center: [20.48771729, 48.38611013], duration: null, easing: easeLinear }, 1],   // TÚRA-056
    //[1, null, false, {center: [20.48771729, 48.38611013], duration: null }, 3],   // TÚRA-057
    //[1, null, false, {center: [20.62526746, 48.48483494], duration: null, easing: easeLinear }, 1],   // TÚRA-058
    //[1, null, false, {center: [20.62526746, 48.48483494], duration: null }, 3],   // TÚRA-059
    [4, null, false, {center: [20.73759101, 48.537645], duration: null, zoom: 8.2, easing: easeLinear }, 1],   // TÚRA-060 // bódvaszilas
    // [1, null, false, {center: [20.91541277, 48.37061565], duration: null, easing: easeLinear }, 1.1 ],   // TÚRA-061
    //[1, null, false, {center: [20.91541277, 48.37061565], duration: null },4 ],   // TÚRA-062
    // [1, null, false, {center: [21.0278286, 48.36548043], duration: null, easing: easeLinear }, 1],   // TÚRA-063
    // [1, null, false, {center: [21.32551942, 48.37629422], duration: null, easing: easeLinear }, 1],   // TÚRA-064
    //[1, null, false, {center: [21.32551942, 48.37629422], duration: null }, 3],   // TÚRA-065
    //[1, null, false, {center: [21.51968201, 48.355932], duration: null }, 3],   // TÚRA-066
    // [1, null, false, {center: [21.51968201, 48.355932], duration: null, easing: easeLinear }, 1],   // TÚRA-067
    [3, null, false, {center: [21.74561625, 48.33209208], duration: null, bearing: 170, pitch:70, easing: easeLinear }, 1],   // TÚRA-143
    // [1, null, false, {center: [21.83000287, 48.33079705], duration: null, easing: easeLinear }, 1],   // TÚRA-142
    // [1, null, false, {center: [21.96297313, 48.24639652], duration: null, easing: easeLinear }, 1],   // TÚRA-141
    [1, null, false, {center: [22.11654866, 48.13234694], duration: null, bearing: 190, easing: easeLinear }, 1],   // TÚRA-140
    // [1, null, false, {center: [22.16651459, 47.997513], duration: null , easing: easeLinear }, 1],   // TÚRA-139
    // [1, null, false, {center: [22.12731509, 47.8372044], duration: null, easing: easeLinear }, 1],   // TÚRA-138
    // [1, null, false, {center: [22.04511978, 47.69321931], duration: null, easing: easeLinear }, 1],   // TÚRA-137
    // [1, null, false, {center: [21.97179333, 47.60183741], duration: null, easing: easeLinear }, 1],   // TÚRA-136
    // [1, null, false, {center: [21.81515293, 47.52920146], duration: null, easing: easeLinear }, 1],   // TÚRA-135
    //[1, null, false, {center: [21.68998456, 47.44895244], duration: null }, 3],   // TÚRA-134
    // [1, null, false, {center: [21.86597372, 47.4222102], duration: null, easing: easeLinear }, 1],   // TÚRA-133
    //[1, null, false, {center: [21.89202536, 47.38250386], duration: null }, 3],   // TÚRA-132
    //[3, null, false, {center: [21.82297598, 47.28523225], duration: null, bearing: 190, easing: easeLinear }, 1],   // TÚRA-131
    //[1, null, false, {center: [21.80074833, 47.18763039], duration: null }, 3],   // TÚRA-130
    // [1, null, false, {center: [21.70185827, 47.24382543], duration: null, easing: easeLinear }, 1.13],   // TÚRA-129
    // [1, null, false, {center: [21.53230617, 47.21235629], duration: null, easing: easeLinear }, 1],   // TÚRA-128
    // [1, null, false, {center: [21.45603015, 47.12870868], duration: null, easing: easeLinear }, 1],   // TÚRA-127
    // [1, null, false, {center: [21.5930396, 47.01985042], duration: null , easing: easeLinear }, 1],   // TÚRA-126
    // //[1, null, false, {center: [21.60099122, 46.9701838], duration: null }, 3],   // TÚRA-125
    // [1, null, false, {center: [21.48675639, 46.92199793], duration: null, easing: easeLinear }, 1],   // TÚRA-124
    // [1, null, false, {center: [21.34267862, 46.89867439], duration: null, easing: easeLinear }, 1],   // TÚRA-123
    // [1, null, false, {center: [21.21465667, 46.93941606], duration: null, easing: easeLinear }, 1],   // TÚRA-122
    [3, null, false, {center: [21.08584095, 46.96991023], duration: null, bearing: 220, easing: easeLinear }, 1],   // TÚRA-121
    [0.5, null, false, {center: [20.94353662, 47.03405389], duration: null, easing: easeLinear }, 1],   // TÚRA-120
    // //[1, null, false, {center: [20.91648371, 47.15402127], duration: null }, 3],   // TÚRA-119
    // [1, null, false, {center: [20.74830521, 47.10010249], duration: null, easing: easeLinear }, 1],   // TÚRA-118
    // [1, null, false, {center: [20.631169, 47.00128086], duration: null  , easing: easeLinear }, 1],   // TÚRA-117
    // [1, null, false, {center: [20.54147722, 46.86528335], duration: null, easing: easeLinear }, 1],   // TÚRA-116
    // [1, null, false, {center: [20.56154762, 46.70687257], duration: null, easing: easeLinear }, 1],   // TÚRA-115
    // [1, null, false, {center: [20.55038509, 46.61690013], duration: null, easing: easeLinear }, 1],   // TÚRA-114
    // [1, null, false, {center: [20.40644651, 46.54219544], duration: null, easing: easeLinear }, 1],   // TÚRA-113
    // [1, null, false, {center: [20.19210077, 46.52468273], duration: null, easing: easeLinear }, 1],   // TÚRA-112
    // [1, null, false, {center: [20.09761216, 46.36202433], duration: null, easing: easeLinear }, 1],   // TÚRA-111
    //[1, null, false, {center: [19.97139898, 46.32691278], duration: null }, 3],   // TÚRA-110
    [3, null, false, {center: [19.88692112, 46.27449027], duration: null, bearing: 210, easing: easeLinear }, 1],   // TÚRA-109
    //[1, null, false, {center: [19.74809626, 46.28990546], duration: null }, 3],   // TÚRA-108
    //[1, null, false, {center: [19.65788274, 46.25554141], duration: null, easing: easeLinear }, 1],   // TÚRA-107
    [1, null, false, {center: [19.52598373, 46.31386056], duration: null, bearing: 270, easing: easeLinear }, 1],   // TÚRA-106
    // //[1, null, false, {center: [19.52598373, 46.31386056], duration: null }, 3],   // TÚRA-105
    // [1, null, false, {center: [19.28576353, 46.36349501], duration: null, easing: easeLinear }, 1],   // TÚRA-104
    // [2, null, false, {center: [19.12108857, 46.34948251], duration: null, easing: easeLinear }, 1],   // TÚRA-103
    // //[3, null, false, {center: [18.98801825, 46.27899394], duration: null }, 3],   // TÚRA-102
    // //[1, null, false, {center: [18.93089456, 46.19301978], duration: null }, 3],   // TÚRA-101
    // //[1, null, false, {center: [18.82769335, 46.20151302], duration: null }, 3],   // TÚRA-100
    // //[1, null, false, {center: [18.85093425, 46.32817396], duration: null }, 3],   // TÚRA-099
    // [1, null, false, {center: [18.71195505, 46.34876404], duration: null, easing: easeLinear }, 1],   // TÚRA-098
    // //[1, null, false, {center: [18.60611592, 46.28882711], duration: null }, 3],   // TÚRA-097
    // //[1, null, false, {center: [18.64255535, 46.21474143], duration: null }, 3],   // TÚRA-096
    // [1, null, false, {center: [18.4708089, 46.22494157], duration: null, easing: easeLinear }, 1],   // TÚRA-095
    // //[1, null, false, {center: [18.47909173, 46.20926057], duration: null }, 3],   // TÚRA-094
    // [1, null, false, {center: [18.31929204, 46.18488442], duration: null, easing: easeLinear }, 1],   // TÚRA-093
    // [1, null, false, {center: [18.0752529, 46.15279388], duration: null , easing: easeLinear }, 1],   // TÚRA-092
    // [1, null, false, {center: [17.88516202, 46.25543578], duration: null, easing: easeLinear }, 1],   // TÚRA-091
    // //[1, null, false, {center: [17.73296972, 46.27190355], duration: null }, 3],   // TÚRA-090
    [4, null, false, {center: [17.69534469, 46.35634255], duration: null, pitch: 60, easing: easeLinear }, 1],   // TÚRA-089
//    [0.5, null, false, {center: [17.57715817, 46.43354377], bearing: 300, duration: null, easing: easeLinear }, 1],   // TÚRA-088
    // [1, null, false, {center: [17.42309376, 46.49666061], duration: null, easing: easeLinear }, 1],   // TÚRA-087
    // [1, null, false, {center: [17.24554532, 46.48555908], duration: null, easing: easeLinear }, 1],   // TÚRA-086
    // //[1, null, false, {center: [17.10917984, 46.55837516], duration: null }, 3],   // TÚRA-085
    // [1, null, false, {center: [16.98512608, 46.49861631], duration: null, easing: easeLinear }, 1],   // TÚRA-084
    // [1, null, false, {center: [16.78158233, 46.50729018], duration: null, easing: easeLinear }, 1],   // TÚRA-083
    //[1, null, false, {center: [16.70275929, 46.53755954], duration: null }, 3],   // TÚRA-082
    [2, null, false, {center: [16.76676439, 46.65507309], duration: null, bearing: 300, easing: easeLinear }, 1],   // TÚRA-081
    [0.5, null, false, {center: [16.69752551, 46.77347051], duration: null, bearing: 340, pitch: 50, easing: easeLinear }, 1],   // TÚRA-080
    // 1, null, false, {center: [16.5769637, 46.84576181], duration: null , easing: easeLinear }, 1],   // TÚRA-079
    //[1, null, false, {center: [16.576964, 46.845762], duration: null }, 3],   // TÚRA-078
    //[1, null, false, {center: [16.42093287, 46.83875828], duration: null }, 3],   // TÚRA-077
    [1, null, false, {center: [16.49722049, 46.9380387], bearing: 0, duration: null, easing: easeLinear }, 1],   // TÚRA-076
    //[1, null, false, {center: [16.67753883, 46.98975148], duration: null }, 3],   // TÚRA-075
    //[1, null, false, {center: [16.677539, 46.989751], duration: null }, 3],   // TÚRA-074
    //[1, null, false, {center: [16.56494984, 47.22161316], duration: null, easing: easeLinear }, 1],   // TÚRA-073
//    [1, null, false, {center: [16.49066195, 47.32437606], duration: null, easing: easeLinear }, 1],   // TÚRA-072
    //[1, null, false, {center: [16.505462, 47.341459], duration: null }, 3],   // TÚRA-071
    //[1, null, false, {center: [21.41328691, 48.54198739], duration: null }, 4]   // TÚRA-070, 
    [5, null, false, {center: [19.504940712358163, 47.17971705313664 ], duration: null, zoom: 6.8, bearing:0, pitch: 0 }, 1],   // TÚRA-072
  ]
} 

function prepareAnimations(anims) {
  var animct = 0 // Object.keys(anims.anims).length
  for (let an of anims.anims) {
    animct = animct + an[0]
  }
  var timeRangeMSec = recordingLengthMinutes*60*1000 
  const displayStepMSec = timeRangeMSec / animct
  var fireTime = 0 ;

  for (let an of anims.anims) {
    an[1] = fireTime
    fireTime = fireTime + an[0] * displayStepMSec
  }
  for (let an of anims.anims) {
    if (an[3]) 
      an[3].duration = an[0] * displayStepMSec * an[4] // duration time oversized
  }
  return anims
}

function easeInCubic(t) {
  return t * t * t;
}
function easeLinear(t) {
  return t ;
}

function delay(time) {
  return new Promise(resolve => setTimeout(resolve, time));
}

export default function PlaybackController(props) {
  const map = useSelector((state) => state.ui.map)
  const timeTo = useSelector((state) => state.ui.displayTime.timeTo) ;
  const viewport = useSelector((state) => state.viewport.viewport)  
  const allLocations =  useSelector((state) => state.viewport.itemMoLocations)
  const itemTrajectoryVisible = useSelector((state) => state.ui.itemTrajectoryVisible) ;
  
  const animRef = useRef(prepareAnimations(anims))
  if (!animRef.current) animRef.current = prepareAnimations(anims) 

  // storing last update not to update too often:
  const lastUpdateTime = useRef(new Date().getTime()) 

  const setLayerTimeFilters = async (trailTime) => {
    //console.log('setLayerTimeFilters', trailTime)
    // layers: t-1, ..., t-10 
    // TODO: layer names can be collected using the viewport definition
    const layers = ['t-1', 't-2', 't-3', 't-4', 't-5'] // , 't-6', 't-7', 't-8', 't-9', 't-10'
    for (let l of layers) {
      if ((map!== "undefined" ) && (map !== null)){
        //console.log(trailTime)

        if (trailTime==null) map.setFilter(l, false) ;
        else map.setFilter(l, ['<', ['number', ['get', 'timeTo']], trailTime]);
      }  
    }
  }  
  
  useEffect(() => {
    //console.log('PlaybackController useEffect [map]', map)
    if (! props.initialSubview) {
    }
    // cleanup: 
    return () => {
    }
  }, [map])

  useEffect(() => {
    //console.log('PlaybackController useEffect [map, timeTo]', timeTo)

    // only update when necessary, and last update not too close in time: 
    // 24 FPS (motion pictures): 41.667 msec
    if ( (new Date().getTime()) - lastUpdateTime.current > 41 ) {
      // set trajectory time filtering on map layer: 
      setLayerTimeFilters(timeTo)

      // only update when necessary: 
      var item = null
      var nonfilteredlocations = null
      var locations = []
      var itemId = null
      if (map && props.initialSubview ) {
        // find item for subview key: 
        viewport.items.map( (aitem, index) => {
          const conf = JSON.parse(aitem.config)
          // exclude hidden items: 
          if ((conf) && (conf.hidden)) return ;
          var aitemId = aitem.viewport_item_id ;
          // console.log(aitemId, props.initialSubview)
          var key = 'nokey'
          try {
            key = conf.key 
          }
          catch {
            ; 
          }
          if (key == props.initialSubview) {
            // console.log('subview found:', key)
            item = aitem 
            nonfilteredlocations =  allLocations[aitemId]
            itemId = aitemId
            // filter on display time range: 
            if (nonfilteredlocations != null) {
              for (var i = 0; i < nonfilteredlocations.length && nonfilteredlocations[i].time <= timeTo; i++) {
                locations.push(nonfilteredlocations[i])
              }  
            }
          }
        }) 

        if ( itemTrajectoryVisible[itemId] && locations && (locations.length>3)) {
        
          let avglength = 600
          if (locations.length < avglength) avglength = locations.length

          const latavg = (arr) => arr.reduce((prev, curr) => prev + curr.lat, 0) / arr.length; 
          const lonavg = (arr) => arr.reduce((prev, curr) => prev + curr.lon, 0) / arr.length; 
          
          const locs1 = locations.slice(locations.length-Math.floor( avglength/2), locations.length-1)
          const locs2 = locations.slice(locations.length-avglength, locations.length-Math.floor( avglength/2))
    
          let p1 = point([lonavg(locs1), latavg(locs1)])
          let p2 = point([lonavg(locs2), latavg(locs2)])
          
          // calculate bearing: 
          let brng = bearing(p2, p1)
          if (brng<0) brng = 180 + 180 + brng
          // console.log(barr, "--->", bavg)
          var whereto = {center: [locations[locations.length-1].lon, locations[locations.length-1].lat], 
                          //duration: 1, 
                          speed: 0.05, // 0.01,
                          //screenSpeed: 0.01, 
                          curve: 1,
                          //duration: 5000,
                          bearing: brng,
                          //easing(t) { return t; }
                          easing: easeLinear 
                        } 
          // set zoom and pitch for the first segment, then don't bother: 
          if (locations.length < 1000) {
            whereto["pitch"] = 65;
            whereto["zoom"] = 14.5; 
          }
          map.easeTo(whereto)
        }
        lastUpdateTime.current = new Date().getTime()
    }
    else {
      //console.log('too frequent update')
    }
  }}, [map, timeTo])

  return  
}